const MAP_SETTINGS = {
  attribution: 5,
  maxZoom: 18,
  level: 2,
  zoomControl: false
}

class LeafletMap {
  constructor() {
    this.resize = this.resize.bind(this)
    this.render = this.render.bind(this)
  }

  initialize() {
    this.currentVector = null
    this.map = L.map(this.el.attr('id'), {
      zoomControl: false,
      renderer: L.svg()
    }).setView([50.688889, 9.6325398], 5)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', MAP_SETTINGS).addTo(
      this.map
    )

    new L.Control.Zoom({ position: 'topright' }).addTo(this.map)

    $('.map').on('resize', this.resize)
    this.resize()
  }

  async resize() {
    return new Promise(resolve => {
      this.el.css('height', $('#leaflet').css('height', '100%'))
      if (this.map) {
        this.map.invalidateSize()
      }
      resolve()
    })
  }

  async render(layers = [], { fitBounds = true }) {
    return new Promise(resolve => {
      if (this.currentVector) {
        this.map.removeLayer(this.currentVector)
      }

      const vector = L.featureGroup(layers)
      this.map.addLayer(vector)

      if (fitBounds) {
        const bounds = vector.getBounds()
        if (bounds.isValid()) {
          this.map.fitBounds(bounds)
        }
      }

      this.currentVector = vector
      resolve()
    })
  }
}

export default LeafletMap
